<template>
    <div>
        <AppHeader />
        <div class="container">

            <div class="warning-message-container">
                <h3 class="warning-message">Não feche ou saia da tela até que o checklist seja enviado</h3>
            </div>

            <div class="status-message-container">
                <h3 class="status-message"> {{ status }}</h3>
            </div>

            <div class="logs" v-if="logArray.length > 0">
                <span
                    class="log-item"
                    v-for="(item, index) in logArray"
                    v-bind:key="index"
                >
                    {{ item }}
                </span>
            </div>
        </div>

        <FooterComponent />
    </div>
</template>

<script>
import FooterComponent from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import Database from "@/controller/database";

export default {
    components: {
        FooterComponent,
        AppHeader: Header
    },
    data: function () {
        return {
            logArray: this.$store.state.uploadChangelog.logArray,
            inspections: [],
            transmitPendings: false,
            status: "Enviando"
        };
    },
    methods: {
        async displayTransmission() {
            const database = new Database();
            await database
                .createOrOpenDatabase({ listInspection: true })
                .then((response) => (this.inspections = response))
                .catch(() => (this.inspections = []));

            for (let i = 0; i < this.inspections.length; i++) {
                let vistoria = this.inspections[i];
                if (vistoria.status == "Pendente") {
                    this.transmitPendings = true;
                }
            }
        },
        async iniciarTransmissao() {
            const db = new Database();
            await db
                .createOrOpenDatabase({ transmitInspection: true })
                .then(() => {
                    this.$store.commit("updateLogArray", "ENVIO FINALIZADO !");
                    this.status = "Enviado"
                })
                .catch((error) => {
                    this.$store.commit("updateLogArray", `FALHA NO ENVIO: ${error}`);
                    this.status = "Erro ao enviar checklist"
                });
        },
    },
    mounted: async function () {
        await this.displayTransmission();

        if (this.transmitPendings) {
            await this.iniciarTransmissao();
        } else {
            this.$router.push({ path: "/home" });
        }
    },
    destroyed: function () {
        this.$store.commit("clearLogArray");
    },
};
</script>

<style scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #343a40;
    height: 60px;
}

.header img,
.header .dropdown {
    margin: 10px;
}

.header img,
.header .dropdown {
    margin: 10px;
}

button {
    margin: 8px;
}

div.container {
    display: flex;
    flex-direction: column;
    padding: 32px;
    gap: 16px;
    height: 100vh;
}

div.warning-message-container {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(255, 237, 136);
    border-radius: 16px;
    padding: 16px;
}

.warning-message {
    text-align: center;
    font-size: 1.25rem;
}

div.status-message-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
}

.status-message {
    text-align: center;
    font-size: 3.5rem;
}

div.logs {
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: #f0f0f0;
    border-radius: 16px;
    padding: 18px;
    position: relative;
    max-height: 600px;
    overflow-y: auto;
    scroll-behavior: auto;
}

span.log-item {
    font-size: 14px;
    margin: 4px;
}
</style>
